import {
    NinchatCodeForkIcon,
    NinchatCodeIcon,
    NinchatGithubIcon,
} from 'components/Icon'
import {
    styledAction,
    styledName,
} from './styles'
import {NinchatStoreMessage} from 'api/types/store'
import React from 'react'
import {styled} from 'stitches/config'

const StyledAction = styled('span', styledAction)
const StyledName = styled('span', styledName)

const MessageHeader = (props: {message: NinchatStoreMessage}): React.ReactElement => {
    const {message} = props

    const {
        pusher,
        ref,
        repository,
    } = message

    const branch = ref?.replace('refs/heads/', '')

    return (
        <>
            <a href={repository?.url} rel='noopener noreferrer' target='_blank'>
                <StyledName><NinchatGithubIcon size={16} /><span>{`${repository?.organization}/${repository?.name}`}</span></StyledName>
            </a>
            <StyledName>({pusher?.name }):</StyledName>
            {!!message.created &&
                <StyledAction>created</StyledAction>}
            {!!message.deleted &&
                <StyledAction>deleted</StyledAction>}
            <a
                href={`${repository?.url}/tree/${branch}`}
                rel='noopener noreferrer'
                target='_blank'
            >
                <StyledName><NinchatCodeForkIcon size={16} /><span>{branch}</span></StyledName>
            </a>
        </>
    )
}

const PushView = (props: {message: NinchatStoreMessage}): React.ReactElement => {
    const {message} = props

    return (
        <ul>
            {message.commits?.map((commit) => (
                <li key={commit.hash}>
                    <MessageHeader message={message} />
                    <span>{commit.message.replace(/\n\s*\n/gu, '\n')} <a href={commit.url} rel='noopener noreferrer' target='_blank'><NinchatCodeIcon size={16} /></a></span>
                </li>))}
            {(!!message.created || !!message.deleted) &&
                <li key={message.id}>
                    <MessageHeader message={message} />
                </li>}
            {!message.created && !message.deleted && !message.commits &&
                <pre>{JSON.stringify(message, null, 2)}</pre>}
        </ul>
    )
}

export default PushView
